import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getCountries = createApiThunk<Country[], void>({
  action: 'countries',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_COUNTRIES,
  responseKey: 'countries',
})

export const getCountriesWithClubs = createApiThunk<Country[], void>({
  action: 'countriesWithClubs',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_COUNTRIES_WITH_CLUBS,
  responseKey: 'countries',
})
